import { render } from "./SupportCreate.vue?vue&type=template&id=7cc53f83&scoped=true"
import script from "./SupportCreate.vue?vue&type=script&lang=js"
export * from "./SupportCreate.vue?vue&type=script&lang=js"

import "./SupportCreate.vue?vue&type=style&index=0&id=7cc53f83&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc53f83"]])

export default __exports__